import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import axios from 'axios';

import imgLogoDE from "../../images/logo_de.png"
import imgLogoFR from "../../images/logo_fr.png"
import imgMilkBottle from "../../images/milk_bottle.png"
import imgHeadlineDE from "../../images/headline_de.svg"
import imgHeadlineFR from "../../images/headline_fr.svg"

import imgMapDe from "../../images/map_DE.png"
import imgMapFr from "../../images/map_FR.png"
import imgMapMobileDe from "../../images/map_mobile_DE.png"
import imgMapMobileFr from "../../images/map_mobile_FR.png"

/* icons */
import iconArrowDown from "../../images/icons/arrow_down.svg"
import iconStarSingle from "../../images/icons/star_single.svg"
import iconStarDoubleRight from "../../images/icons/star_double_right.svg"
import iconStarDoubleLeft from "../../images/icons/star_double_left.svg"
import iconLine from "../../images/icons/line.svg"

const Header = (props) => {
    const [resources, setResources] = useState({});
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    let imgLogo = imgLogoDE;
    let imgHeadline = imgHeadlineDE;

    let imgMap = imgMapDe;
    let imgMapMobile = imgMapMobileDe;

    let navigate = useNavigate();
    const location = useLocation();

    const { language } = useParams();

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            break;
        case ("fr" || "FR"):
            imgLogo = imgLogoFR;
            imgHeadline = imgHeadlineFR;
            imgMap = imgMapFr;
            imgMapMobile = imgMapMobileFr;
            break;
        default:
            break;
    }

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const changeLanguage = (newLanguage) => {
        // Get current path and replace language parameter
        const pathParts = location.pathname.split('/');
        pathParts[1] = newLanguage; // Replace language part
        const newPath = pathParts.join('/');
        navigate(newPath);
    };

    // Determine which language to show (the opposite of current)
    const displayLanguage = language === 'de' ? 'DE' : 'FR';
    const targetLanguage = language === 'de' ? 'fr' : 'de';

    // Select map image based on screen size
    const mapImage = isMobile ? imgMapMobile : imgMap;

    return (
        <>
            <div className="container page-container p-0">

                {/* Logo and Language Switcher Overlay */}
                <div className="header-overlay">
                    <div className="row align-items-start">
                        <div className="col-6">
                            <img src={imgLogo} alt="Logo" className="header-logo" />
                        </div>
                        <div className="col-6 text-end position-relative">
                            <img src={imgMilkBottle} alt="Milk Bottle" className="milk-bottle-img" />
                            <div
                                className="language-switcher-circle"
                                onClick={() => changeLanguage(targetLanguage)}
                            >
                                {displayLanguage}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="ps-4 pe-4">
                    {/* headliner image */}
                    <img src={imgHeadline} alt="Banner" className="header-banner-img" />

                    {props.registrationOpen && (
                        <>
                            {/* Welcome description */}
                            <div className="row">
                                {/*<div*/}
                                {/*    className="col-md-12  text-center"*/}
                                {/*    onClick={props.onScrollToRegistration}*/}
                                {/*    style={{ cursor: 'pointer' }}*/}
                                {/*>*/}
                                {/*    <span className="button-register-scroll">{resources?.HeaderRegisterNow}</span>*/}
                                {/*    <div>*/}
                                {/*        <img className="button-register-scroll-icon" src={iconArrowDown} alt="" />*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                                <div className="col-md-12 text-center title-margin-top">
                                    <span className="title">{resources?.HeaderHello} {props.firstName}</span>
                                    <img src={iconStarDoubleRight} className="icon-star-double-right" alt="" />
                                </div>

                                <div className="col-md-12 mt-4 text-center">
                                    <span dangerouslySetInnerHTML={{ __html: resources?.HeaderDescription }}></span>
                                </div>
                            </div>

                            <br />
                            <br />

                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <img src={iconLine} className="icon-star-line img-fluid" alt="" />
                                </div>
                            </div>


                            {/* When and Where */}
                            <div className="row title-margin-top">
                                <div className="col-md-12 text-center">
                                    <img src={iconStarSingle} className="icon-star-single" style={{ marginRight: "3px" }} alt="" />
                                    <span className="title">{resources?.HeaderWhenWhere}</span>
                                    <img src={iconStarSingle} className="icon-star-single-small" style={{ marginLeft: "-12px", marginTop: "22px" }} alt="" />
                                </div>
                                <div className="col-md-12 text-center">
                                    <span className="subtitle">{resources?.HeaderWhenWhereDate}</span>
                                </div>
                                <div className="col-md-12 mt-4 text-center">
                                    <a href="https://www.google.com/maps/search/Allmend+Messe/@47.0345902,8.3008587,673m/data=!3m2!1e3!4b1?entry=ttu&g_ep=EgoyMDI2MDMyMi4wIKXMDSoASAFQAw%3D%3D"
                                        target="_blank" rel="noreferrer">
                                        <img src={mapImage} alt="" className="img-fluid" />
                                    </a>
                                </div>
                            </div>

                            {/* Program */}
                            <div className="row card-program title-margin-top">
                                <div className="col-md-12 text-center">
                                    <img src={iconStarDoubleLeft} className="icon-star-double-left" alt="" />
                                    <span className="title">{resources?.HeaderProgram}</span>
                                </div>

                                    <div className="col-12 col-md-6 text-center text-md-end f-black mt-4">{resources?.HeaderProgram1}</div>
                                    <div className="col-12 col-md-6 text-center text-md-start mt-0 mt-md-4" >{resources?.HeaderProgram1Description}</div>

                                <div className="col-12 col-md-6 text-center text-md-end f-black mt-4 mt-md-0">{resources?.HeaderProgram2}</div>
                                    <div className="col-12 col-md-6 text-center text-md-start">{resources?.HeaderProgram2Description}</div>

                                <div className="col-12 col-md-6 text-center text-md-end f-black mt-4 mt-md-0">{resources?.HeaderProgram3}</div>
                                    <div className="col-12 col-md-6 text-center text-md-start">{resources?.HeaderProgram3Description}</div>

                                <div className="col-12 col-md-6 text-center text-md-end f-black mt-4 mt-md-0">{resources?.HeaderProgram4}</div>
                                    <div className="col-12 col-md-6 text-center text-md-start">{resources?.HeaderProgram4Description}</div>

                                <div className="col-12 col-md-6 text-center text-md-end f-black mt-4 mt-md-0">{resources?.HeaderProgram5}</div>
                                    <div className="col-12 col-md-6 text-center text-md-start">{resources?.HeaderProgram5Description}</div>

                                <div className="col-12 col-md-6 text-center text-md-end f-black mt-4 mt-md-0">{resources?.HeaderProgram6}</div>
                                    <div className="col-12 col-md-6 text-center text-md-start">{resources?.HeaderProgram6Description}</div>

                                <div className="col-12 col-md-6 text-center text-md-end f-black mt-4 mt-md-0">{resources?.HeaderProgram7}</div>
                                    <div className="col-12 col-md-6 text-center text-md-start">{resources?.HeaderProgram7Description}</div>
                            </div>

                            {/* Arrival */}
                            <div className="row title-margin-top">
                                <div className="col-md-12 text-center">
                                    <img src={iconStarDoubleLeft} className="icon-star-double-left" alt="" />
                                    <span className="title">{resources?.HeaderArrival}</span>
                                </div>
                                <div className="col-md-12 mt-4 text-center">
                                    <span dangerouslySetInnerHTML={{ __html: resources?.HeaderArrivalDescription }}></span>
                                </div>
                            </div>
                        </>
                    )}
                </div>


            </div>
        </>
    )
}

export default Header